import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@roberttamas/ui";
import { useTranslation } from "react-i18next";

import { LocaleFlag } from "@/components/locale-flag";
import { setUiLanguage, UI_LANGUAGES, type UiLanguage } from "@/i18n";

/** UI-language switcher for the sidebar user block (distinct from the
 * product's content-locale pickers like `LanguageCombobox`). */
export function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? "en") as UiLanguage;

  return (
    <Select value={current} onValueChange={(value) => setUiLanguage(value as UiLanguage)}>
      <SelectTrigger className="h-9 w-full" aria-label={t("nav.language")}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {UI_LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <LocaleFlag tag={lang.flagTag} />
              {/* Native names on purpose, so users always recognize their language. */}
              {lang.nativeName}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
